import './styles/styles.scss';

import Highway from '@dogstudio/highway/src/highway';
import 'picturefill/dist/picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
// import '@lottiefiles/lottie-player';
// import 'lottie-web/build/player/lottie';
import Glide from '@glidejs/glide';

// import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import CustomRenderer from './renderer.js';
import Fade from './fade.js';

import markerIcon from './assets/marker.svg';

lazySizes.cfg.expand = 300;
lazySizes.cfg.expFactor = 1.25;
lazySizes.init();

const root = document.getElementsByTagName('html')[0];
const body = document.getElementsByTagName('body')[0];
let wrapper = document.querySelector('.wrapper');
// let wrapper = document.getElementsByTagName('main')[0];
let navBurger = document.querySelector('.navbar-burger');
let navBar = document.querySelector('.navbar');
let navMenu = document.querySelector('.navbar-menu');
let activeMenuItem = document.querySelector('.current-menu-item');
let scrollTopBtn = document.querySelector('#scrolltop');
let alm_is_animating = false;

let ww = window.innerWidth,
    wh = window.innerHeight;

let pageIn;
let pageOut;
let pageName;
let pageType;
pageName = wrapper.firstElementChild.getAttribute('id');
pageType = wrapper.firstElementChild.getAttribute('data-router-view');
// let logo = document.querySelector('#logo');
// console.log('pageName', pageName);

function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

var hash = window.location.hash;
if (hash !== '') {
    // console.log('hash', hash);
    gsap.to(window, {
        duration: 1,
        scrollTo: {
            y: hash,
            // offsetY: navBar.offsetHeight + 50
            // (ww > 768 ? navbarMenu.offsetHeight : navbar.offsetHeight) + (ww >= 1920 ? 99 : (ww > 768 ? 24 : -1)) //-navbarMenu.offsetHeight-1
        },
        ease: 'power2',
        onComplete: () => {
            // document.querySelector(hash + ' .collapse-button').click();
        }
    });
}

const H = new Highway.Core({
    renderers: {
        name: CustomRenderer
    },
    transitions: {
        default: Fade,
    }
});

H.on('NAVIGATE_OUT', ({ from }) => {
    pageOut = from.view;
    pageType = pageOut.getAttribute('data-router-view');
    pageName = pageOut.getAttribute('id');
    // activeMenuItem = document.querySelector('.navbar-item.current-menu-item');
    // typeof(activeMenuItem) != 'undefined' && activeMenuItem != null ? activeMenuItem.classList.remove('current-menu-item') : null;
    // if (navMenu.classList.contains('is-active')) {
    //     root.classList.remove('is-clipped');
    //     body.classList.remove('is-clipped');
    //     navMenu.classList.remove('is-active');
    //     navBar.classList.remove('is-active');
    //     navMenuBtn.classList.toggle('is-active');
    // }
    if (pageName === 'home') {
        body.classList.remove('is-clipped');
    }
});

H.on('NAVIGATE_IN', ({ to, trigger, location }) => {
    pageIn = to.view;
    pageType = pageIn.getAttribute('data-router-view');
    pageName = pageIn.getAttribute('id');

    // gsap.set(wrapper, { paddingTop: navBar.offsetHeight });
    // gsap.set(pageIn.firstElementChild, { minHeight: wh - navBar.offsetHeight - footer.offsetHeight });
    if (pageName === 'home') {
        body.classList.add('is-clipped');
    }
    // activeMenuItem = document.querySelector('.item-' + pageName);
    // typeof(activeMenuItem) != 'undefined' && activeMenuItem != null ? activeMenuItem.classList.add('current-menu-item') : null;
});

H.on('NAVIGATE_END', ({ to, trigger, location }) => {
    pageIn = to.view;
    pageType = pageIn.getAttribute('data-router-view');
    pageName = pageIn.getAttribute('id');
    // postContent = pageIn.querySelector('.post-content');
    console.log('pageName', pageName);

    if (pageName === 'home') {
        initMap();
        showIntro();
    }
});

document.addEventListener('DOMContentLoaded', function() {
    if (body.classList.contains('home')) {
        body.classList.add('is-clipped');
        initMap();
        showIntro();
    }
});

function initMap() {
    function addMarker(coordinates) {
        var marker = new google.maps.Marker({
            position: coordinates,
            map: map,
            title: '',
            draggable: false
        });
    }

    const styles = {
        default: [],
        hide: [{
                featureType: "poi",
                stylers: [{ visibility: "off" }],
            },
            // {
            //     featureType: "poi.medical",
            //     stylers: [{ visibility: "off" }],
            // },
            // {
            //     featureType: "transit",
            //     elementType: "labels.icon",
            //     stylers: [{ visibility: "off" }],
            // },
        ],
    };

    const stuttgart = { lat: 48.77541053338064, lng: 9.176029951747154 };
    let mapID = body.classList.contains('home') ? 'werkemap' : null;
    const map = new google.maps.Map(document.getElementById(mapID), {
        zoom: 13,
        center: stuttgart,
        minZoom: 10,
        // maxZoom: 18,
        restriction: {
            latLngBounds: {
                north: 52,
                south: 48,
                east: 11,
                west: 8,
            },
        },
        styles: styles['hide'],
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: ["roadmap", "terrain"],
        },
        gestureHandling: 'greedy'
    });
    const iconBase = '/wp-content/themes/publicartstuttgart/js/';
    // const icons = {
    //     pas: {
    //         url: iconBase + markerIcon,
    //         size: new google.maps.Size(20, 32),
    //         // The origin for this image is (0, 0).
    //         origin: new google.maps.Point(0, 0),
    //         // The anchor for this image is the base of the flagpole at (0, 32).
    //         anchor: new google.maps.Point(0, 32),
    //     }
    // };
    const markerImg = {
        url: iconBase + markerIcon,
        size: new google.maps.Size(20, 30),
        scaledSize: new google.maps.Size(20, 30),
        anchor: new google.maps.Point(0, 30)
    }
    const infowindow = new google.maps.InfoWindow();
    // if (body.classList.contains('home')) {
    //     const marker = new google.maps.Marker({
    //         position: stuttgart,
    //         map: map,
    //     });
    // } else {}
    let locationMarker = [];
    let werke = Array.from(document.getElementsByClassName('werk-data'));
    if (werke.length > 0) {
        werke.forEach(el => {
            locationMarker.push({
                nr: el.getAttribute('data-nr'),
                poslat: parseFloat(el.getAttribute('data-lat')),
                poslng: parseFloat(el.getAttribute('data-lng')),
                // icon: 'pas',
                artist: el.getAttribute('data-artist') !== '' ? el.getAttribute('data-artist') : null,
                title: el.getAttribute('data-title') !== '' ? el.getAttribute('data-title') : null,
                year: el.getAttribute('data-year') !== '' ? el.getAttribute('data-year') : null,
                bezirk: el.getAttribute('data-bezirk') !== '' ? el.getAttribute('data-bezirk') : null,
                address: el.getAttribute('data-address') !== '' ? el.getAttribute('data-address') : null,
                img: el.getAttribute('data-img') !== '' ? el.getAttribute('data-img') : null,
            });
        });
    }

    for (var i = 0; i < locationMarker.length; i++) {
        var marker = new google.maps.Marker({
            position: { lat: locationMarker[i]['poslat'], lng: locationMarker[i]['poslng'] },
            map: map,
            icon: markerImg //icons[locationMarker[i]['icon']].icon,
                // icon: new google.maps.MarkerImage(locationMarker[i]['marker'], null, null, null, new google.maps.Size(24, 24)),
                // title: locationMarker[i][0],
                // animation: google.maps.Animation.DROP,
        });

        google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
                // infowindow.maxWidth = 300;
                infowindow.setContent(
                    '<div class="pas-content"><img src="' + locationMarker[i].img + '"><div class="pt-2 pb-4 px-3"><p class="has-margin-0">' + locationMarker[i].artist + '</p><p class="has-margin-0">' + locationMarker[i].title + (locationMarker[i].year !== null ? ', ' + locationMarker[i].year : '') + '</p><p class="has-margin-0">' + locationMarker[i].address + '</p></div></div>'
                );
                infowindow.open(map, marker);
            }
        })(marker, i));
    };
    // console.log(locationMarker)
}

function showIntro() {
    let pasIntro = document.querySelector('#pas-intro');
    let pasIntroButton = document.querySelector('#pas-intro .toggle');
    let pasIntroContent = document.querySelector('#pas-intro .content');
    pasIntroButton.addEventListener('click', function(e) {
        e.preventDefault();
        pasIntro.classList.toggle('is-active');
        // if (pasIntro.classList.contains('is-active')) {
        //     gsap.to(pasIntroContent, { duration: .3, autoAlpha: 0 });
        //     gsap.to(pasIntro, { duration: .4, height: '50px', delay: .1 });
        // } else {
        //     gsap.set(pasIntro, { height: 'auto' });
        //     // gsap.from(pasIntro, { duration: .5, height: 0 });
        //     gsap.to(pasIntroContent, { duration: .3, autoAlpha: 1 });
        // }
        // gsap.to(pasIntro, {
        //     duration: .5,
        //     width: pasIntro.classList.contains('is-active') ? '50px' : ww / 3,
        //     delay: pasIntro.classList.contains('is-active') ? .2 : 0,
        //     ease: 'power2',
        //     onComplete: () => {
        //         pasIntro.classList.toggle('is-active');
        //     }
        // });
    });
}

// gsap.set(wrapper, { paddingTop: navBar.offsetHeight });

// initGalleries();
// projectFilter();

// navBurger.onclick = function(e) {
//     e.preventDefault();
//     root.classList.toggle('is-clipped');
//     body.classList.toggle('is-clipped');
//     navMenu.classList.toggle('is-active');
//     navBar.classList.toggle('is-active');
//     navBurger.classList.toggle('is-active');
//     // if (navBurger.classList.contains('has-text-white')) {
//     //     // navBurger.classList.remove('has-text-white');
//     //     // navBurger.classList.add('has-text-bluedark');
//     // } else {
//     //     navBurger.classList.contains('is-active') ? navBurger.classList.add('has-text-white') : 
//     // }
//     // if (logo.querySelector('#logo').classList.contains('has-text-white')) {
//     //     // logo.querySelector('#logo').classList.remove('has-text-white');
//     //     // logo.querySelector('#logo').classList.add('has-text-bluedark');
//     // } else {
//     //     logo.querySelector('#logo').classList.remove('has-text-bluedark', 'has-text-primary');
//     //     logo.querySelector('#logo').classList.add('has-text-white');
//     // }
//     // gsap.to(search, { height: wh - navbar.offsetHeight });
//     // gsap.to(search, { height: navbar.classList.contains('is-scrolled') ? wh - navbar.offsetHeight : wh - navbar.offsetHeight - largeHeader.offsetHeight });
// };


// function projectFilter() {
//     var filterButtonAll = document.querySelector('.allprojects');
//     var filterButtons = document.querySelectorAll('.is-filter');
//     if (filterButtons.length > 0) {
//         filterButtons.forEach(button => {
//             button.addEventListener('click', function(e) {
//                 var filter = this;
//                 console.log('filter ', filter);
//                 almFilter(filter);
//                 if (filter === filterButtonAll) {
//                     filterButtonAll.classList.add('is-hidden');
//                 } else {
//                     filterButtonAll.classList.remove('is-hidden');
//                 }
//             });
//         });
//     }
// }

// function almFilter(el) {
//     var data;
//     var transition = 'fade';
//     var speed = 500;
//     var filter = el;
//     let filterActive = document.querySelector('.is-filter.is-hovered');
//     if (typeof(filterActive) != 'undefined' && filterActive != null) {
//         filterActive.classList.remove('is-hovered');
//     }
//     if (typeof(filter) != 'undefined' && filter != null) {
//         data = filter.dataset; //filter.classList.contains('is-active') ? document.querySelector('.is-filter.allitems').dataset : 
//         console.log('filter data ', data);
//         filter.classList.add('is-hovered');
//         alm_is_animating = true;
//         ajaxloadmore.filter(transition, speed, data);
//     }
// }

// window.almFilterComplete = function() {
//     alm_is_animating = false;
//     gsap.to(window, {
//         duration: .75,
//         scrollTo: { y: 0 },
//         ease: 'power2'
//     });
// }

// ALM Callbacks
// window.almComplete = function(alm) {
//     console.log(alm);
// }

// scrollTopBtn.addEventListener('click', function(e) {
//     e.preventDefault();
//     gsap.to(window, {
//         duration: 1,
//         scrollTo: {
//             y: '#top',
//             autoKill: true
//         },
//         ease: 'power2'
//     });
// });

// function initGalleries() {
//     const $gallery = Array.from(document.querySelectorAll('.gallery'));
//     if ($gallery.length > 0) {
//         $gallery.forEach(el => {
//             if (typeof(el) != 'undefined' && el != null) {
//                 let bullets = el.querySelector('.glide__bullets');
//                 if (typeof(bullets) != 'undefined' && bullets != null) {
//                     let slides = Array.from(el.querySelectorAll('.glide__slide'));
//                     if (slides.length > 0) {
//                         for (var i = 0; i < slides.length; i++) {
//                             bullets.innerHTML += '<button class="has-padding-0 glide__bullet" data-glide-dir="=' + i + '"><span class="">' + slides[i].id + '</span></button>';
//                         }
//                     }
//                 }

//                 let gallery = new Glide(el, {
//                     gap: 0,
//                     startAt: 0,
//                     perView: 1,
//                     // autoplay: el.classList.contains('is-autoplay') ? 2500 : false,
//                     animationDuration: 750,
//                     animationTimingFunc: 'ease-in-out'
//                 });

//                 gallery.mount();
//                 // gsap.set('.glide__slide--active p', {
//                 //     opacity: 1,
//                 // });
//                 // if (el.classList.contains('case-gallery')) {
//                 //     gallery.on('run.before', function() {
//                 //         // gallery.querySelector('.glide__slide--active')
//                 //         console.log('before', el.querySelector('.glide__slide--active'))
//                 //         gsap.to('.glide__slide--active p', {
//                 //             opacity: 0,
//                 //             duration: .25,
//                 //             ease: 'power3.easeOut',
//                 //         });
//                 //     });
//                 //     gallery.on('run.after', function() {
//                 //         console.log('after', el.querySelector('.glide__slide--active'))
//                 //         gsap.to('.glide__slide--active p', {
//                 //             opacity: 1,
//                 //             duration: .25,
//                 //             ease: 'power3.easeOut',
//                 //         });
//                 //     });
//                 // }
//             }
//         });
//     }
// }

function windowResize() {
    ww = window.innerWidth;
    wh = window.innerHeight;
    // console.log('RESIZED: ww:', ww, ' | wh:', wh);
}

window.addEventListener('resize', windowResize);